import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/context/AuthContext.tsx';
import AppLayout from '@/components/layout/AppLayout.tsx';
import MvpHeader from '@/components/layout/MvpHeader.tsx';
import DataPrivacyPage from '@/pages/DataPrivacyPage.tsx';

/**
 * Privacy & terms must be PUBLIC (visible before registering/logging in, per
 * GDPR transparency). Logged-in users keep the full app shell (sidebar); for
 * everyone else we render a lightweight public shell with the shared header.
 */
export default function DataPrivacyRoute() {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();

  if (isAuthenticated) {
    return (
      <AppLayout>
        <DataPrivacyPage />
      </AppLayout>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <MvpHeader />
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground no-underline"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('auth.backLink', 'Indietro')}
        </Link>
        <DataPrivacyPage />
      </main>
    </div>
  );
}
